import styled from "styled-components";
import React, { useEffect, useRef, useState } from "react";
import JoditEditor from "jodit-react";
import { nameSearchCRM } from "../../../DataApi/crm/nameSearchCRM";
import { useSession } from "../../../authentications/SessionContext";
import ReactSelect from "react-select";
import { create } from "../../../DataApi/create";
import moment from "moment/moment";
import { SCHEDULE_ACTIVITY_INPUT_DATE_FORMAT } from "../../../utilities/constants";

const StyledLabel = styled.label`
  color: #b0b7c3;
  font-family: "Inter";
  font-size: 16px;
  font-weight: 600;
  text-align: left;
`;

const FormContainer = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 20px;
  padding: 12px;
  .form-control {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    height: 56px !important;
    font-weight: 400;
    line-height: 1.5;
    color: #ccc !important;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #f3f3f3 !important;
    border-radius: 13px !important;
  }
  .jodit-status-bar a.jodit-status-bar-link {
    display: none !important;
  }
  .jodit .jodit-workplace .jodit-wysiwyg,
  .jodit .jodit-workplace .jodit-wysiwyg_iframe,
  .jodit-container .jodit-workplace .jodit-wysiwyg,
  .jodit-container .jodit-workplace .jodit-wysiwyg_iframe {
    min-height: 300px !important;
  }
`;
const Button = styled.button`
  background-color: #f8f9fa;
  color: #b0b7c3;
  width: 200px;
  min-width: 100px;
  border: none;
  border-radius: 15px;
  padding: 10px 20px;
  font-family: "Inter";
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
  &:hover,
  &:focus,
  &:active {
    background-color: #ff5837;
    color: #fff;
  }
`;

const SchuduleScreen = ({ handleCloseModal, cardId }) => {
  const editor = useRef(null);
  const { sessionInfo } = useSession();
  const { company_id, context } = sessionInfo;
  const [activityTypeList, setActivityTypeList] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [inputs, setInputs] = useState({
    activity_type_id: "",
    date_deadline: moment().format(SCHEDULE_ACTIVITY_INPUT_DATE_FORMAT),
    summary: "",
    user_id: "",

    //

    // activity_type_id: 1,
    // date_deadline: "2024-04-17",
    // summary: false,
    // user_id: 2,
    // res_model_id: 467,
    // res_id: 105,
    // recommended_activity_type_id: false,
    // note: "<p><br></p>",
  });

  const handleChangeSelect = (value, { name }) => {
    setInputs({ ...inputs, [name]: value });
  };
  const handleChangeActivityType = (value, { name }) => {
    setInputs({ ...inputs, [name]: value });
  };
  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setInputs({ ...inputs, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      ...inputs,
      activity_type_id: inputs?.activity_type_id?.value || false,
      date_deadline: moment(inputs.date_deadline || null).format(
        SCHEDULE_ACTIVITY_INPUT_DATE_FORMAT
      ),
      summary: inputs?.summary || false,
      user_id: context.uid,
      res_model_id: 467,
      res_id: cardId,
      recommended_activity_type_id: false,
      note: editor.current.value,
    };
    // console.log(inputs.date_deadline, "response");
    let response = await create({
      payload,
      company_id,
      context,
      model: "mail.activity",
    });
    response = JSON.parse(response);
    if (response?.result) {
      handleCloseModal();
    }
  };
  const fetchData = async ({ model, setState }) => {
    let response = await nameSearchCRM({
      model,
      company_id,
      context,
    });
    response = JSON.parse(response);
    const responseList =
      response?.result?.map((item) => ({
        label: item[1],
        value: item[0],
      })) || [];
    setState(responseList);
  };

  useEffect(() => {
    fetchData({
      model: "mail.activity.type",
      setState: setActivityTypeList,
    });
    fetchData({ model: "res.users", setState: setUsersList });
  }, []);

  return (
    <div className="container" style={{ maxWidth: "1200px", padding: "10px" }}>
      <FormContainer className="row">
        <h2
          className="me-2 mb-2 "
          style={{ fontFamily: "Inter", color: "#323B4B", fontWeight: 600 }}
        >
          Schudule Activity
        </h2>

        <div className="col-md-6 mb-2">
          <div>
            <StyledLabel className="form-label">Activity Type</StyledLabel>
            <ReactSelect
              value={inputs.activity_type_id}
              options={activityTypeList}
              name="activity_type_id"
              onChange={handleChangeActivityType}
            />
          </div>
        </div>
        <div className="col-md-6 mb-2">
          <div className="input-group">
            <StyledLabel className="form-label">Due Date</StyledLabel>
            <input
              type="date"
              name="date_deadline"
              value={inputs.date_deadline}
              onChange={handleChangeInput}
              className="form-control"
            />
          </div>
        </div>

        <div className="col-md-6 mb-2">
          <div className="input-group">
            <StyledLabel className="form-label">Summary</StyledLabel>
            <input
              type="text"
              name="summary"
              value={inputs.summary}
              onChange={handleChangeInput}
              className="form-control"
            />
          </div>
        </div>
        <div className="col-md-6 mb-2">
          <div>
            <StyledLabel className="form-label">Assigned To</StyledLabel>
            <ReactSelect
              value={inputs.user_id}
              options={usersList}
              name="user_id"
              onChange={handleChangeSelect}
            />
          </div>
        </div>
        <div className="col-md-12 ">
          <JoditEditor
            name="note"
            value={inputs.note}
            ref={editor}
            config={{
              showCharsCounter: false,
            }}
          />
        </div>
        <div className="d-flex justify-center mt-2 gap-3">
          <Button onClick={handleSubmit}>Schudule</Button>
          {/* <Button>Mark Done </Button>
          <Button>Done and Schudule</Button>
          <Button>Discard</Button> */}
        </div>
      </FormContainer>
    </div>
  );
};

export default SchuduleScreen;
